module.exports = __webpack_public_path__ + "img/response.b043db55.png";